<script>
	//NPM Modules
	import collect from 'collect.js';
	import { createEventDispatcher } from 'svelte';
	// Components
	import LoadingButton from '@/Components/LoadingButton.svelte';
	// Partials
	import CheckBox from '@/Partials/Racing/ProductBetType/_CheckBox.svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	// Constants
	import { BetType } from '@/Constants/Bet.js';
	import { Products } from '@/Constants/RaceProducts.js';

	export let products;
	export let betTypes;
	export let selectedBetTypes = [];
	export let title = '';
	export let sending = false;
	export let showClassificationDefaults = false;

	$: selectedBetTypes && resetSelectedBetTypes();

	const dispatch = createEventDispatcher();

	let _selectedBetTypes = [];
	let bonusAllowlist = {
		products: [Products.NSW, Products.SUP, Products.TATTS],
		betTypes: [BetType.Win, BetType.Place]
	};

	function resetSelectedBetTypes() {
		_selectedBetTypes = collect(selectedBetTypes.toArray());
	}

	function onClickSave() {
		dispatch('clickSave', preparePayload());
	}

	function preparePayload() {
		let payload = [];
		_selectedBetTypes.each((item) => {
			payload.push({
				product_id: item.product.id,
				bet_type_id: item.bet_type.id,
				bonus_percentage: item.bonus_percentage > 0 ? item.bonus_percentage : null
			});
		});
		return payload;
	}
</script>

<div class="flex flex-col items-center max-w-7xl bg-white">
	<div class="flex items-center justify-between w-full p-2">
		<div class="flex-1" />
		<div class="font-semibold uppercase">{title}</div>
		<div class="flex flex-1 text-right">
			{#if $ACLStore && ACLStore.granted('classifications.update')}
				<button
					on:click={() => (_selectedBetTypes = collect([]))}
					class="px-4 py-2 ml-auto text-white rounded-md bg-grey focus:outline-none hover:bg-black"
				>
					Reset
				</button>
				<LoadingButton
					on:click={onClickSave}
					loading={sending}
					className="px-4 py-2 text-white bg-black rounded-md hover:bg-grey ml-4"
					>Save
				</LoadingButton>
			{/if}
		</div>
	</div>
	<table class="w-full max-w-7xl whitespace-nowrap table-fixed">
		<thead>
			<tr class="text-xs text-center uppercase">
				<th class="px-6 pt-5 pb-4 font-medium" />
				{#each products.all() as product}
					<th class="font-medium">
						<div class="flex items-center justify-center">
							{product.display_name}
						</div>
					</th>
				{/each}
			</tr>
		</thead>
		<tbody class="bg-white">
			{#each betTypes.all() as betType}
				<tr class="text-center border cursor-pointer">
					<td class="p-4 px-6 pr-4 font-semibold">{betType.name}</td>
					{#each products.all() as product}
						<CheckBox {product} {betType} bind:_selectedBetTypes {bonusAllowlist} {showClassificationDefaults} />
					{/each}
				</tr>
			{/each}
		</tbody>
	</table>
</div>
